import { Component } from '@angular/core';
import {CalendarModule} from "primeng/calendar";
import {FormsModule} from "@angular/forms";
import {ChartModule} from "primeng/chart";
import {NgForOf, NgIf} from "@angular/common";
import {StatisticService} from "../statistic.service";
import {HttpResponse} from "@angular/common/http";
import {TableModule} from "primeng/table";
import {MessagesModule} from "primeng/messages";

export interface TopPayers {
  id: string
  name: string
  total: string
  childrenAge: string[]
}

@Component({
  selector: 'app-top-payers',
  standalone: true,
  imports: [
    CalendarModule,
    FormsModule,
    ChartModule,
    NgForOf,
    NgIf,
    TableModule,
    MessagesModule
  ],
  templateUrl: './top-payers.component.html',
})
export class TopPayers {
  topPayers: TopPayers[] = []
  from: Date = new Date()
  to: Date = new Date()
  loading = false;
  errorMessage?: any[]


  constructor(private statisticService: StatisticService) {
  }

  load() {
    this.loading = true;
    this.errorMessage = undefined
    this.statisticService.findParentTopPayersStatistic(this.from, this.to).subscribe(
      {
        next: (response: HttpResponse<TopPayers[]>) => {
          this.topPayers = response.body ?? [];
        },
        error: (error: any) => {
          console.error(error);
          if (error.status === 0) {
            this.errorMessage = [{ severity: 'error', detail: 'Server not responding' }];
          } else {
            this.errorMessage = [{ severity: 'error', detail: error.detail }];
          }
          this.loading = false
        },
        complete: () => this.loading = false
      }
    )
  }
}
